import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NOfficeBuildingIcon = function NOfficeBuildingIcon(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#1C1327' : _ref$stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 21"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      clipPath: "url(#clip0_2553_29689)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M3.93 5.16v12.89m0 0h11.66m-11.66 0H2.26m1.67 0H8.1m7.5-4.67V4.72c0-.44-.18-.87-.49-1.18-.31-.31-.74-.49-1.18-.49H5.59m10.84 15h-5m0 0v-4.17c0-.22-.09-.43-.24-.59a.807.807 0 00-.59-.24H8.93c-.22 0-.43.09-.59.24-.16.16-.24.37-.24.59v4.17m3.33 0H8.1M7.87 6.38h.83M7.68 9.71h.83m2.92-3.33h.83m-.83 3.33h.83M17.55 19.15L1.75 2.75"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_2553_29689",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H17.3V17.9H0z",
          transform: "translate(1 2)"
        })
      })
    })]
  }));
};
export default NOfficeBuildingIcon;